/**
 * Constants representing the various sources from which a request to find a replacement support worker can originate.
 *
 * This is mainly used for segment tracking purposes in src/app/pages/scheduling/services/find-replacement-support-segment.service.ts.
 *
 * This is called when a support worker needs to be replaced for a planned session, and the source indicates
 * how the request was initiated, such as through email, notification, SMS, or specific sections of the application.
 */
export const FIND_REPLACEMENT_SUPPORT_WORKER_SOURCE = {
  email: 'email',
  notification: 'notification',
  sms: 'sms',
  client_cancelled_session: 'client_cancelled_session',
  planned_session_details: 'planned_session_details',
  dashboard: 'dashboard',
  manage_sessions: 'manage_sessions',
  launch_modal: 'launch_modal',
} as const;

export const FIND_REPLACEMENT_SUPPORT_WORKER_SOURCE_MAPPED_VALUE = {
  [FIND_REPLACEMENT_SUPPORT_WORKER_SOURCE.email]: 'Cancelled session email',
  [FIND_REPLACEMENT_SUPPORT_WORKER_SOURCE.notification]: 'Cancelled session notification',
  [FIND_REPLACEMENT_SUPPORT_WORKER_SOURCE.sms]: 'Cancelled session SMS',
  [FIND_REPLACEMENT_SUPPORT_WORKER_SOURCE.client_cancelled_session]: 'Client cancelled session',
  [FIND_REPLACEMENT_SUPPORT_WORKER_SOURCE.planned_session_details]: 'Planned session details',
  [FIND_REPLACEMENT_SUPPORT_WORKER_SOURCE.dashboard]: 'Dashboard',
  [FIND_REPLACEMENT_SUPPORT_WORKER_SOURCE.manage_sessions]: 'Manage sessions',
  [FIND_REPLACEMENT_SUPPORT_WORKER_SOURCE.launch_modal]: 'Launch modal',
} as const;

export type FindReplacementSupportWorkerSourceType = keyof typeof FIND_REPLACEMENT_SUPPORT_WORKER_SOURCE;
